import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { EMPTY, Subject, Subscription, timer } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';

import { DiaDoMes } from '../_classes/dia-do-mes';
import { FrqFrequenciaMes } from '../_classes/frq-frequencia-mes';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';
import { EnvService } from '../_servicos/env.service';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { Util } from './../_classes/util';
import { ModalAlertaService } from './../shared/modal-alerta.service';
import { Servidor } from '../_classes/servidor';
import { PontoFrequenciaComponent } from '../ponto-frequencia/ponto-frequencia.component';
import { Retorno } from '../_classes/retorno';
import { PontoService } from '../_servicos/ponto.service';

@Component({
  selector: 'app-frequencia',
  templateUrl: './frequencia.component.html',
  styleUrls: ['./frequencia.component.scss'],
})
export class FrequenciaComponent implements OnInit {
  private readonly recurso: string = 'frequencia'; //mesmo que a rota

  @Input() simples = false;
  carregando = false;
  mes: string = null;
  ano: string = null;
  anoMesLimiteMin: number = 0;
  anoMesLimiteMax: number = 0;
  mesesDisponiveis: string[];

  dc: string[] = ['d', 'd1', 'es1', 'j1', 't1'];

  erros$ = new Subject<boolean>();
  erros: 0;
  celular = false;

  iDataSource: Subscription;
  //iDataSourcePonto: Subscription;
  frequenciaMes: FrqFrequenciaMes = null;

  //dataSource$: Observable<DiaDoMes[]>;
  //dataSourcePonto$: Observable<Ponto[]>;
  //dataSource: MatTableDataSource<DiaDoMes>;
  //dataSourcePonto: MatTableDataSource<Ponto>;
  //idComprovantePontoVisualizando: number = 0;

  dataSourceCel: MatTableDataSource<DiaDoMes>;

  @ViewChild('freq') freq: PontoFrequenciaComponent;

  servidor: Servidor = null;

  length = 100;
  pageSize = 40;

  itensAjuda = [
    {
      titulo: 'Data',
      texto: 'Data do mês referenciado',
    },
    {
      titulo: 'Entrada1',
      texto: 'Primeiro horário registrado',
    },
    {
      titulo: 'Saída1',
      texto: 'Segundo horário registrado',
    },
    {
      titulo: 'Entrada2',
      texto: 'Terceiro horário registrado',
    },
    {
      titulo: 'Saída2',
      texto: 'Quarto horário registrado',
    },
    {
      titulo: 'Jornada',
      texto: 'Jornada diária de trabalho',
    },
    {
      titulo: 'Total',
      texto: "Total do tempo 'no trt' calculado pelos horários registrados",
    },
  ];

  graficoValor: number[] = [0, 0, 0];
  graficoAjuda: any = null;
  graficoEtiqueta: any = null;
  mostrarGrafico = false;
  graficoValorMaximo = 0;
  arquivoUrl: any;

  minutosEmHoras(min: number) {
    let r: string = '';
    //console.log('minutos', min);
    if (!min) {
      min = 0;
    }

    if (min === 0) {
      r = '0';
    } else {
      const horas: number = Math.floor(min / 60);
      r =
        new String(horas).padStart(2, '0') +
        ':' +
        new String(min - horas * 60).padStart(2, '0');
      /*Util.padLeft(horas, '0', 2) +
        ':' +
        Util.padLeft(min - horas * 60, '0', 2);*/
    }

    return r;
  }

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private sanitizer: DomSanitizer,
    private service: RestService,
    private _pS: PontoService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {
    //this.dataSource = new MatTableDataSource([]);
    //this.dataSourcePonto = new MatTableDataSource([]);
    this.dataSourceCel = new MatTableDataSource([]);
    const hoje = new Date();

    this.ano = hoje.getFullYear().toString();
    this.mes = Util.padLeft(hoje.getMonth() + 1, '0', 2);

    this.anoMesLimiteMax = Number(this.ano.toString() + this.mes.toString());
  }

  ngOnInit() {
    this.atualizar();
  }

  buscarMesLimiteMinimo() {
    this._pS
      .getPrimeiraDataDeFrequencia(this.env.servidor.servidorSrh2.matServidor)
      .subscribe((a: Retorno) => {
        if (a.resultado) {
          //console.log(a);

          const ano: string = String(new Date(a.resultado.data).getFullYear());
          const mes: string = String(
            new Date(a.resultado.data).getMonth() + 1
          ).padStart(2, '0');

          this.anoMesLimiteMin = Number(`${ano}${mes}`);
          this.preencherMesesDisponiveis();
        }
      });
  }

  largura() {
    //console.log('largura da tela', Util.larguraDaTela());
    if (Util.larguraDaTela() > 768) {
      this.celular = false;
      return 600;
    } else {
      this.celular = true;
      return 300;
    }
  }

  preencherMesesDisponiveis() {
    this.mesesDisponiveis = new Array<string>();
    let continuar: boolean = true;
    let mes: number = parseInt(this.anoMesLimiteMin.toString().substring(4, 6));
    let ano: number = parseInt(this.anoMesLimiteMin.toString().substring(0, 4));

    while (continuar) {
      this.mesesDisponiveis.push(
        this.anoMesExtenso(ano + '/' + mes.toString().padStart(2, '0'))
      );
      if (
        this.anoMesLimiteMax ===
        parseInt(ano.toString() + mes.toString().padStart(2, '0'))
      ) {
        continuar = false;
      }
      if (mes === 12) {
        mes = 1;
        ano = ano + 1;
      } else {
        mes = mes + 1;
      }

      if (ano === 2030) {
        continuar = false;
      }
    }
    this.mesesDisponiveis = this.mesesDisponiveis.reverse();
  }

  irMesExtenso(mesAno: any) {
    mesAno = new String(mesAno.srcElement.innerText).trim();
    this.ano = mesAno.split('/')[0];

    switch (mesAno.split('/')[1].trim()) {
      case 'Janeiro': {
        this.mes = '01';
        break;
      }
      case 'Fevereiro': {
        this.mes = '02';
        break;
      }
      case 'Março': {
        this.mes = '03';
        break;
      }
      case 'Abril': {
        this.mes = '04';
        break;
      }
      case 'Maio': {
        this.mes = '05';
        break;
      }
      case 'Junho': {
        this.mes = '06';
        break;
      }
      case 'Julho': {
        this.mes = '07';
        break;
      }
      case 'Agosto': {
        this.mes = '08';
        break;
      }
      case 'Setembro': {
        this.mes = '09';
        break;
      }
      case 'Outubro': {
        this.mes = '10';
        break;
      }
      case 'Novembro': {
        this.mes = '11';
        break;
      }
      case 'Dezembro': {
        this.mes = '12';
        break;
      }
    }

    this.atualizarFrequencia();
  }

  /*
  baixarComprovante(pTemplate: TemplateRef<any>, id: number) {
    //console.log('baixarComprovante-id', id);
    this.idComprovantePontoVisualizando = id;
    this.carregando = true;
    if (this.env.servidor) {
      this.service.getComprovantePonto(id).subscribe((a: Comprovante) => {
        this.executarAoMostrarOuDownloadBlob(
          a.bbComprovante,
          pTemplate,
          true,
          'Comprovante.pdf'
        );
      });
    }
  }

  downloadDentroDaVisualizacao() {
    this.baixarComprovante(null, this.idComprovantePontoVisualizando);
  }

  executarAoMostrarOuDownloadBlob(
    x: Blob,
    template: TemplateRef<any>,
    pBaixar: boolean,
    nomeDoArquivo: string
  ) {
    //console.log('kk-executarAoMostrarOuDownloadBlob(x)', x, nomeDoArquivo);
    const blob = new Blob([Util.Base64ToBlob(x)], {
      type: 'application/pdf',
    });
    this.arquivoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      window.URL.createObjectURL(blob)
    );

    //if (!pBaixar) {
    //      this.modalRef = this.modalService.show(template, this.config);
    //} else {
    let newVariable: any = window.navigator;
    if (newVariable && newVariable.msSaveOrOpenBlob) {
      newVariable.msSaveOrOpenBlob(blob); //console.log('Carregando aterado2', this.carregando);
      return;
    }
    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(blob);

    let link = document.createElement('a');
    link.href = data;
    link.download = nomeDoArquivo;
    // this is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );

    setTimeout(function () {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data);
      this.carregando = false;
    }, 100);
    //}
    this.carregando = false;
  }*/

  atualizarFrequencia() {
    this.carregando = true;
    this.t = timer(this.env.timeoutGenerico).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
      }
    });
    /*
    if (!this.simples) {
      this.dataSource$ = this.service
        .listarFrequencia(
          this.env.servidor.servidorSrh2.matServidor,
          this.mes + this.ano
        )
        .pipe(
          tap((a) => {
            this.executarAoCarregarDatasource(a);
          }),
          take(1),
          catchError((e) => {
            this.handleError(e);
            return EMPTY;
          })
        );
    }*/

    this.iDataSource = this.service
      .getFrequenciaMes(
        this.env.servidor.servidorSrh2.matServidor,
        this.ano + '-' + this.mes
      )
      .pipe(
        tap((a) => {}),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      )
      .subscribe((a) => this.executarAoCarregarDatasourceM(a));
  }

  alterarMes(direcao: 'voltar' | 'avancar') {
    let m = Number(this.mes);
    let a = Number(this.ano);

    if (direcao === 'voltar') {
      if (m === 1) {
        m = 12;
        a = a - 1;
      } else {
        m = m - 1;
      }
    } else if (direcao === 'avancar') {
      if (m === 12) {
        m = 1;
        a = a + 1;
      } else {
        m = m + 1;
      }
    }

    let anoMesAtual: number = Number(a.toString() + Util.padLeft(m, '0', 2));
    if (
      anoMesAtual >= this.anoMesLimiteMin &&
      anoMesAtual <= this.anoMesLimiteMax
    ) {
      this.mes = Util.padLeft(m, '0', 2);
      this.ano = a.toString();
      this.atualizarFrequencia();
    }
  }

  voltarMes() {
    this.alterarMes('voltar');
  }
  avancarMes() {
    this.alterarMes('avancar');
  }
  /*
  voltarMes() {
    let m = Number(this.mes);
    let a = Number(this.ano);
    if (m === 1) {
      m = 12;
      a = a - 1;
    } else {
      m = m - 1;
    }
    this.mes = Util.padLeft(m, '0', 2);
    this.ano = a.toString();
    this.atualizarFrequencia();
  }

  avancarMes() {
    let m = Number(this.mes);
    let a = Number(this.ano);
    if (m === 12) {
      m = 1;
      a = a + 1;
    } else {
      m = m + 1;
    }
    let anoMesAtual: number = Number(a.toString() + Util.padLeft(m, '0', 2));
    if (
      anoMesAtual >= this.anoMesLimiteMin &&
      anoMesAtual <= this.anoMesLimiteMax
    ) {
      this.mes = Util.padLeft(m, '0', 2);
      this.ano = a.toString();
      this.atualizarFrequencia();
    }
  }*/
  /*
  executarAoCarregarDatasource(x: DiaDoMes[]) {
    //console.log('entrei no executarAoCarregarDatasource');
    //console.table(x);
    this.dataSource = new MatTableDataSource<DiaDoMes>(x);
    this.dataSourceCel = new MatTableDataSource<DiaDoMes>(x);
    this.carregando = false;
  }*/
  /*
  executarAoCarregarDatasourcePonto(x: Ponto[]) {
    //console.log('executarAoCarregarDatasourcePonto');
    //console.table(x);
    this.dataSourcePonto = new MatTableDataSource<Ponto>(x);
    this.carregando = false;
  }*/

  executarAoCarregarDatasourceM(x: FrqFrequenciaMes) {
    if (this.freq) {
      this.freq.mostrar(Number(this.mes), Number(this.ano));
    }

    this.frequenciaMes = new FrqFrequenciaMes(x[0]);
    if (this.frequenciaMes.anoMes) {
      this.desenharGrafico(
        this.frequenciaMes.qtHorasJornada,
        this.frequenciaMes.qtHorasTrabalhadas,
        this.frequenciaMes.qtHorasAtraso
      );
    } else {
      this.frequenciaMes = null;
    }

    this.carregando = false;
  }

  desenharGrafico(jornada: number, trabalhado: number, falta: number) {
    this.graficoValor = new Array<number>();
    this.graficoValor.push(jornada ? jornada : 0);
    this.graficoValor.push(trabalhado ? trabalhado : 0);
    this.graficoValor.push(falta ? falta : 0);
    this.graficoValorMaximo =
      jornada > trabalhado ? (jornada > falta ? jornada : falta) : trabalhado;
    //console.log('graficoValor', this.graficoValor);
    //console.log('frequenciaMes', this.frequenciaMes);
    this.graficoEtiqueta = {
      formatFunction: (value: number, i: number): string => {
        //console.log('v, i', value, i);

        let tipo = '';
        if (i === 0) {
          tipo = 'J';
        } else if (i === 1) {
          tipo = 'T';
        } else {
          tipo = 'F';
        }

        return tipo; // value.toString() + "-" + this.minutosEmHoras(value) + "-" + tipo;
      },
      precision: 15,
      indent: 0,
    };

    this.graficoAjuda = {
      visible: true,
      formatFunction: (value: string, i: number) => {
        let tipo = '';
        if (i === 0) {
          tipo = ' da jornada';
        } else if (i === 1) {
          tipo = ' trabalhado';
        } else {
          tipo = ' para completar jornada';
        }
        return 'Total ' + tipo + '<br>' + this.minutosEmHoras(parseInt(value));
      },
    };

    this.mostrarGrafico = true;
  }

  ehFDS(d) {
    let r: boolean = false;

    if (d) {
      let dia: Date = new Date(d);
      if (dia.getDay() === 6 || dia.getDay() === 0) {
        r = true;
      }
    }
    return r;
  }
  /*
  qualClasseMostrar(r: DiaDoMes, tipo: string) {
    let classe: string = '';
    if (r.ehDiaNaoTrabalhado) {
      if (r.ehDiaNaoTrabalhadoQualTipo.startsWith('FDS-')) {
        classe = 'FDS';
      } else {
        classe = r.ehDiaNaoTrabalhadoQualTipo;
      }
    } else {
      classe = 'NORMAL';
    }
    ////console.log(r);
    if (
      classe === 'NORMAL' &&
      !r.entrada1 &&
      !r.entrada2 &&
      !r.saida1 &&
      !r.saida2 &&
      r.jornada
    ) {
      ////console.log("deveria ser do tipo FALTA");
      classe = 'FALTA';
    }
    ////console.log("retorno");
    ////console.log(tipo + "-" + classe);
    return tipo + '-' + classe;
  }*/

  tipoPorExtenso(dia: DiaDoMes) {
    let r: string = '';
    let d: Date = new Date(dia.data);
    if (d.getDay() === 6) {
      r = 'SÁBADO';
    } else {
      if (d.getDay() === 0) {
        r = 'DOMINGO';
      }
    }
    if (
      dia.ehDiaNaoTrabalhado &&
      !dia.ehDiaNaoTrabalhadoQualTipo.startsWith('FDS-')
    ) {
      if (r) {
        r = r + ' - ';
      }
      r = r + dia.ehDiaNaoTrabalhadoQualTipo;
      if (dia.dsMotivacao) {
        if (r) {
          r = r + ' ';
        }
        r = r + dia.dsMotivacao;
      }
    }
    if (dia.entrada1 || dia.entrada2 || dia.saida1 || dia.saida2) {
      r = r + ' (registro de trabalho ';
      let rAdicional: string = '';
      if (dia.entrada1) {
        rAdicional = 'E:' + dia.entrada1;
      }
      if (dia.saida1) {
        if (rAdicional) {
          rAdicional = rAdicional + ';';
        }
        rAdicional = rAdicional + 'S:' + dia.saida1;
      }
      if (dia.entrada2) {
        if (rAdicional) {
          rAdicional = rAdicional + ';';
        }
        rAdicional = rAdicional + 'E:' + dia.entrada2;
      }
      if (dia.saida2) {
        if (rAdicional) {
          rAdicional = rAdicional + ';';
        }
        rAdicional = rAdicional + 'S:' + dia.saida2;
      }
      r = r + rAdicional + ')';
    }

    return r;
  }
  /*
  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }*/

  anoMesExtenso(vlr: string) {
    let r: string = vlr;
    if (vlr) {
      if (vlr.length === 7) {
        let ano: string = vlr.split('/')[0] + '/';
        switch (vlr.split('/')[1]) {
          case '01': {
            r = 'Janeiro';
            break;
          }
          case '02': {
            r = 'Fevereiro';
            break;
          }
          case '03': {
            r = 'Março';
            break;
          }
          case '04': {
            r = 'Abril';
            break;
          }
          case '05': {
            r = 'Maio';
            break;
          }
          case '06': {
            r = 'Junho';
            break;
          }
          case '07': {
            r = 'Julho';
            break;
          }
          case '08': {
            r = 'Agosto';
            break;
          }
          case '09': {
            r = 'Setembro';
            break;
          }
          case '10': {
            r = 'Outubro';
            break;
          }
          case '11': {
            r = 'Novembro';
            break;
          }
          case '12': {
            r = 'Dezembro';
            break;
          }
        }
        r = ano + r;
      }
    }
    return r;
  }

  atualizar() {
    this.carregando = true;
    this.erros = 0;
    this.t = timer(this.env.timeoutGenerico).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });

    this.servService.getServidorComFuncao2().then(() => this.listar());
  }

  listar() {
    this.servidor = new Servidor(this.env.servidor);
    this.buscarMesLimiteMinimo();
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
    this.atualizarFrequencia();
  }

  periodo(dI: Date, dF: Date) {
    return Util.periodoMesAbreviado(dI, dF);
  }
  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  handleError(e: any) {
    this.erros++;
    this.erros$.next(true);
    this.carregando = false;
    if (!this.simples) {
      this.alertService.mostrarAlertaPerigo(
        'Erro, tente novamente mais tarde',
        e
      );
    }
  }
}
